export interface MessageDraft {
  body: string;
  mediaUrls: string[];
}

export interface ComposeDraft extends MessageDraft {
  toNumber: string;
  fromPhoneNumberId: string;
}

export const EMPTY_MESSAGE_DRAFT: MessageDraft = {
  body: "",
  mediaUrls: [],
};

export const EMPTY_COMPOSE_DRAFT: ComposeDraft = {
  toNumber: "",
  fromPhoneNumberId: "",
  body: "",
  mediaUrls: [],
};
